import { SpecialEventValueTypes } from "../SpecialEventsQuery/SpecialEventsQuery.consts";
import { ASSISTANT_CHANNELS } from "src/utils/core/consts";

export const CallRoutingOptions = {
  HANDOFF: {
    key: "HANDOFF",
    eventType: "HANDOFF",
    eventKey: ""
  },
  HANDOFF_REASON: {
    key: "HANDOFF_REASON",
    eventType: "HANDOFF",
    eventKey: "trigger"
  },
  CALL_ROUTED: {
    key: "CALL_ROUTED",
    eventType: "SUCCESSFUL_ROUTE_SELECTION",
    eventKey: ""
  },
  ROUTE_NAME: {
    key: "ROUTE_NAME",
    eventType: "SUCCESSFUL_ROUTE_SELECTION",
    eventKey: "routeName"
  },
  CALL_TRANSFERED: {
    key: "CALL_TRANSFERED",
    eventType: "TRANSFER_DESTINATION_FROM_ROUTING_TABLES",
    eventKey: ""
  },
  TRANSFER_DESTINATION: {
    key: "TRANSFER_DESTINATION",
    eventType: "TRANSFER_DESTINATION_FROM_ROUTING_TABLES",
    eventKey: "transferDestinationFromRoutingTables"
  },
  TRANSFER_REASON: {
    key: "TRANSFER_REASON",
    eventType: "TRANSFER_REASON",
    eventKey: "reason"
  },
  SMS_SENT: {
    key: "SMS_SENT",
    eventType: "SMS_SENT",
    eventKey: ""
  },
  USER_HUNG_UP: {
    key: "USER_HUNG_UP",
    eventType: "USER_HUNG_UP",
    eventKey: ""
  },
  // Chat only: emitted per turn by the NLU with the detected intent(s) and their category.
  INTENT_NAME: {
    key: "INTENT_NAME",
    eventType: "CONVERSATION_DRIVER",
    eventKey: "userIntent"
  },
  INTENT_CATEGORY: {
    key: "INTENT_CATEGORY",
    eventType: "CONVERSATION_DRIVER",
    eventKey: "conversationDriver"
  }
};

const BaseCallRoutingAttributes = {
  [CallRoutingOptions.HANDOFF.key]: {
    type: CallRoutingOptions.HANDOFF.eventType,
    key: CallRoutingOptions.HANDOFF.eventKey,
    label: "Call handed off",
    valueType: SpecialEventValueTypes.BOOLEAN_INCLUDED
  },
  [CallRoutingOptions.HANDOFF_REASON.key]: {
    type: CallRoutingOptions.HANDOFF_REASON.eventType,
    key: CallRoutingOptions.HANDOFF_REASON.eventKey,
    label: "Handoff reason",
    valueType: SpecialEventValueTypes.DROPDOWN,
    supportsMultiSelect: true
  },
  [CallRoutingOptions.CALL_ROUTED.key]: {
    type: CallRoutingOptions.CALL_ROUTED.eventType,
    key: CallRoutingOptions.CALL_ROUTED.eventKey,
    label: "Call routed",
    valueType: SpecialEventValueTypes.BOOLEAN_INCLUDED
  },
  [CallRoutingOptions.ROUTE_NAME.key]: {
    type: CallRoutingOptions.ROUTE_NAME.eventType,
    key: CallRoutingOptions.ROUTE_NAME.eventKey,
    label: "Route name",
    valueType: SpecialEventValueTypes.DROPDOWN
  },
  [CallRoutingOptions.CALL_TRANSFERED.key]: {
    type: CallRoutingOptions.CALL_TRANSFERED.eventType,
    key: CallRoutingOptions.CALL_TRANSFERED.eventKey,
    label: "Call transfered",
    valueType: SpecialEventValueTypes.BOOLEAN_INCLUDED
  },
  [CallRoutingOptions.TRANSFER_DESTINATION.key]: {
    type: CallRoutingOptions.TRANSFER_DESTINATION.eventType,
    key: CallRoutingOptions.TRANSFER_DESTINATION.eventKey,
    label: "Transfer destination",
    valueType: SpecialEventValueTypes.DROPDOWN
  },
  [CallRoutingOptions.TRANSFER_REASON.key]: {
    type: CallRoutingOptions.TRANSFER_REASON.eventType,
    key: CallRoutingOptions.TRANSFER_REASON.eventKey,
    label: "Transfer reason",
    valueType: SpecialEventValueTypes.DROPDOWN
  },
  [CallRoutingOptions.SMS_SENT.key]: {
    type: CallRoutingOptions.SMS_SENT.eventType,
    key: CallRoutingOptions.SMS_SENT.eventKey,
    label: "SMS sent",
    valueType: SpecialEventValueTypes.BOOLEAN_INCLUDED
  },
  [CallRoutingOptions.USER_HUNG_UP.key]: {
    type: CallRoutingOptions.USER_HUNG_UP.eventType,
    key: CallRoutingOptions.USER_HUNG_UP.eventKey,
    label: "User hung up",
    valueType: SpecialEventValueTypes.BOOLEAN_INCLUDED
  }
};

const IntentAttributes = {
  [CallRoutingOptions.INTENT_NAME.key]: {
    type: CallRoutingOptions.INTENT_NAME.eventType,
    key: CallRoutingOptions.INTENT_NAME.eventKey,
    label: "Intent name",
    valueType: SpecialEventValueTypes.DROPDOWN,
    placeholder: "Select intent",
    supportsMultiSelect: true
  },
  [CallRoutingOptions.INTENT_CATEGORY.key]: {
    type: CallRoutingOptions.INTENT_CATEGORY.eventType,
    key: CallRoutingOptions.INTENT_CATEGORY.eventKey,
    label: "Intent category",
    valueType: SpecialEventValueTypes.DROPDOWN,
    placeholder: "Select category",
    supportsMultiSelect: true
  }
};

export const CallRoutingAttributes = {
  ...BaseCallRoutingAttributes,
  ...IntentAttributes
};

// A hydrated row (saved filter, shared URL) may reference an intent attribute the current
// user cannot select; keep that one attribute so the row stays visible and editable.
export const getCallRoutingAttributes = ({ channel, isIntentFilterEnabled, selectedSubType }) => {
  if (channel === ASSISTANT_CHANNELS.WEB && isIntentFilterEnabled) {
    return CallRoutingAttributes;
  }
  const hydratedIntentAttribute = IntentAttributes[selectedSubType];
  return hydratedIntentAttribute
    ? { ...BaseCallRoutingAttributes, [selectedSubType]: hydratedIntentAttribute }
    : BaseCallRoutingAttributes;
};
